import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "../lib/api";
import { logger } from "../lib/logger";

const DEFAULTS = {
  enable_auctions: true,
  enable_uploads: true,
  enable_stripe_checkout: true,
  enable_registration: true,
  maintenance_mode: false,
  site_announcement: "",
  max_file_size_mb: 10,
};

const SettingsContext = createContext({ settings: DEFAULTS, refresh: () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/public");
      setSettings({ ...DEFAULTS, ...data });
    } catch (err) {
      logger.warn("Public settings fetch failed, using defaults:", err);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(() => ({ settings, refresh }), [settings, refresh]);

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
